import { FC } from 'react';
import { Redirect, RouteComponentProps, Switch } from 'react-router-dom';
import PruRoute from 'src/app/common/components/PruRoute';
import { ModulePermissionProps } from 'src/app/common/module/types';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { FormModeEnum } from '../../types/key-task-summarizer-type';
import KeyTaskSummarizerListingPage from './List/KeyTaskSummarizerListingPage';
import KeyTaskSummarizerDetailForm from './Create/keyTaskSummarizerDetailForm';

type KeyTaskSummarizerPageProps = RouteComponentProps & ModulePermissionProps;

const KeyTaskSummarizerPage: FC<KeyTaskSummarizerPageProps> = ({ match, enableRead, enableCreate, enableUpdate }) => {
  return (
    <Switch>
      <Redirect exact from={match.path} to={`${match.path}/list`} />
      <PruRoute
        exact
        path={`${match.path}/list`}
        render={(props) => (
          <KeyTaskSummarizerListingPage
            {...props}
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
          />
        )}
      />
      <PruRoute
        exact
        path={`${match.path}/edit/:id`}
        render={(props) => (
          <KeyTaskSummarizerDetailForm
            {...props}
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
            formMode={FormModeEnum.EDIT}
          />
        )}
      />
      <PruRoute
        exact
        path={`${match.path}/view/:id`}
        render={(props) => (
          <KeyTaskSummarizerDetailForm
            {...props}
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
            formMode={FormModeEnum.VIEW}
          />
        )}
      />
      <PruRoute
        exact
        path={`${match.path}/create/:from`}
        render={(props) => (
          <KeyTaskSummarizerDetailForm
            {...props}
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
            formMode={FormModeEnum.CREATE}
          />
        )}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default KeyTaskSummarizerPage;
